import { useState } from 'react';
import { useNavigate } from "@tanstack/react-location";
import { Auth } from "../../model/App/Firebase";
import {
    Alert,
    TextInput,
    PasswordInput,
    LoadingOverlay,
    Anchor,
    Paper,
    Title,
    Text,
    Container,
    Group,
    Button,
  } from '@mantine/core';
  
export default function LoginScreen() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");
    const navigate = useNavigate();

    // "Login" button...
    const onLoginPress = () => {
        setIsLoading(true);
        setErrorMessage("");

        Auth.signInWithEmailAndPassword(email, password)
            .then(() => {
                setIsLoading(false);
                setErrorMessage("");
                navigate({ to: "/" });
            }, (error) => {
                setIsLoading(false);
                setErrorMessage(error.message);
            });
    }

    return (
      <Container size={420} my={40}>
        <Title align="center" sx={(theme) => ({ fontFamily: `Greycliff CF, ${theme.fontFamily}`, fontWeight: 900 })}>
          <Text align="center" color="red" weight="bold" style={{ fontSize: "108pt", lineHeight: 1 }}>æ</Text>
          <Text align="center" color="red" weight="bold" style={{ fontSize: "24pt" }}>Aarón Estrada Legal</Text>
          <Text color="red">Patent & Trademark Docket</Text>
        </Title>

        {/*
        <Text color="dimmed" size="sm" align="center" mt={5}>
          Do not have an account yet?{' '}
          <Anchor<'a'> href="#" size="sm" onClick={(event) => event.preventDefault()}>
            Create account
          </Anchor>
        </Text>
        */}
  
        <LoadingOverlay visible={isLoading} />
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
            <TextInput label="Email" placeholder="aaron@aestradalegal.com" required value={email} onChange={(event) => { setEmail(event.target.value); }}  />
            <PasswordInput label="Password" placeholder="Your password" required mt="md" value={password} 
                onChange={(event) => { setPassword(event.target.value); }} 
                onKeyPress={(event) => {  if (event.key === "Enter" || event.charCode === 13) { onLoginPress(); }  }}
            />

            <Group position="apart" mt="md">
                <Anchor<'a'> onClick={() => navigate({ to: "/forgotPassword" })} href="#" size="sm">
                Forgot password?
                </Anchor>
            </Group>
            <Button fullWidth mt="xl" onClick={onLoginPress}>
                Sign in
            </Button>

            {errorMessage ? <Alert color="red" title="Error" mt="md">{errorMessage}</Alert> : null}
        </Paper>
      </Container>
    );
}